import { useEffect } from "react";

// ui components
import "react-datepicker/dist/react-datepicker.css";

import styled from "styled-components";
import { RootState } from "../../store/rootReducer";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PartnerRequest } from "../../interfaces/Partner";
import { getPartnerAsync, selectPartner } from "../../reducers/partner/partner.actions";
import { PermissionMenuName } from "../../interfaces/UserRole";
import Datatables from "../../layouts/Datatables";
// @ts-ignore
import { MUIDataTableMeta } from "mui-datatables";
import { Tooltip } from '@mui/material';
import Zoom from '@mui/material/Zoom';

export const PartnerListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state: RootState) => state.partner.isLoading);
  const errorMessage = useSelector((state: RootState) => state.partner.errorMessage);
  const listPartner = useSelector((state: RootState) => state.partner.listPartner);
  const role = useSelector((state: RootState) => state.authorization.systemAccess[PermissionMenuName.partner].ACCESS);

  useEffect(() => {
    dispatch(getPartnerAsync.request());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createPartner = () => {
    dispatch(selectPartner(null));
    history.push(`/partner/create`);
  }

  const editPartner = (partner: PartnerRequest) => {
    dispatch(selectPartner(partner));
    history.push(`/partner/${partner.CO_ID}`);
  }

  const refresh = () => {
    if (isLoading) return;
    dispatch(getPartnerAsync.request());
  }

  const renderPartner = () => {
    if (errorMessage) {
      return (
        // <tr>
        //   <td colSpan={9} style={{textAlign: 'center'}}>
        //   Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Terdapat kesalahan dalam memuat data: <b>{errorMessage}</b><br/><button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      )
    }

    if (isLoading) {
      return (
        // <tr>
        //   <td colSpan={9} style={{textAlign: 'center'}}>
        //     Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Sedang memuat data &nbsp; <i className="fa fa-refresh fa-spin"></i>
        </div>
      );
    }

    if (listPartner.length === 0) {
      return (
        // <tr>
        //   <td colSpan={9} style={{textAlign: 'center'}}>
        //     Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        //   </td>
        // </tr>

        <div style={{textAlign: 'center'}}>
          Data tidak ditemukan: &nbsp; <button className="btn btn-primary btn-xs" onClick={refresh}>Coba Perbaharui Halaman</button>
        </div>
      );
    }

    // const wrapCellRenderer = (params: GridRenderCellParams) => (
    //   <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
    //     {params.value}
    //   </div>
    // );

    // const actionRenderer = (params: GridRenderCellParams) => (
    //   <>
    //     <button className="btn btn-primary btn-xs" onClick={() => editPartner(params.row)}>
    //       <i className="fa fa-edit" aria-hidden="true"></i>
    //     </button>
    //   </>
    // )

    // const columns: GridColDef[] = [
    //   { field: 'NO', headerName: 'No', width: 32, minWidth: 32, renderCell: wrapCellRenderer },
    //   { field: 'CO_NAME', headerName: 'Nama', width: 195, renderCell: wrapCellRenderer },
    //   { field: 'CO_ALAMAT', headerName: 'Alamat', width: 160, renderCell: wrapCellRenderer },
    //   { field: 'CO_KOTA', headerName: 'Kota', width: 100, renderCell: wrapCellRenderer },
    //   { field: 'NEGARA', headerName: 'Negara', width: 80, valueGetter: (params) => params.row.CO_NEGARA_DETAIL?.name || '-', renderCell: wrapCellRenderer },
    //   { field: 'CO_PIC_NAME', headerName: 'PIC', width: 130, renderCell: wrapCellRenderer },
    //   { field: 'CO_PIC_DEPT', headerName: 'Department', width: 100, renderCell: wrapCellRenderer },
    //   { field: 'CO_PIC_EMAIL', headerName: 'Email', width: 215, renderCell: wrapCellRenderer },
    //   { field: 'actions', headerName: '', width: 30, renderCell: actionRenderer }
    // ];
    
    // return listPartner.map((partner, index) => {
    //   return (
    //     <tr key={partner.CO_ID}>
    //       <td>{index + 1}</td>
    //       <td>{partner.CO_NAME}</td>
    //       <td>{partner.CO_ALAMAT}</td>
    //       <td>{partner.CO_KOTA}</td>
    //       <td>{partner.CO_NEGARA_DETAIL.name}</td>
    //       <td>{partner.CO_PIC_NAME}</td>
    //       <td>{partner.CO_PIC_DEPT}</td>
    //       <td>{partner.CO_PIC_EMAIL}</td>
    //       <td>
    //         <button className="btn btn-primary btn-xs" onClick={() => editPartner(partner)}>
    //           <i className="fa fa-edit" aria-hidden="true"></i>
    //         </button>
    //       </td>
    //     </tr>
    //   );
    // })

    const items = listPartner.map((item, index) => ({
      NO: index + 1,
      id: item.CO_ID,
      NEGARA: item.CO_NEGARA_DETAIL.name,
      ...item,
    }));

    const getHeaderProps = (width: string, padding: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding
        },
      };
    };

    const getCellProps = (width: string, padding: string, align: string) => {
      return {
        style: {
          width: width,
          maxWidth: width,
          padding: padding,
          fontSize: '12px',
          textAlign: `${align}`
        },
      };
    };
    
    const actionRenderer = (value: any, tableMeta: MUIDataTableMeta) => {
      const row = items[tableMeta.rowIndex];

      return (
        <div style={{display: 'flex'}}>
          <Tooltip title="Ubah"
            slots={{
              transition: Zoom,
            }} 
            componentsProps={{
              tooltip: {
                sx: {
                  fontSize: '11px'
                },
              },
            }}>
            <button className="btn btn-primary btn-xs" onClick={() => editPartner(row)}>
              <i className="fa fa-edit" aria-hidden="true"></i>
            </button>
          </Tooltip>
        </div>
      );
    }

    const columns = [
      { 
        name: "NO",
        label: "No",
        options: {
          filter: false,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('50px', '5px 0 5px 0'),
          setCellProps: () => getCellProps('50px', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_NAME",
        label: "Nama",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('24%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('24%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_ALAMAT",
        label: "Alamat",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('16%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('16%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_KOTA",
        label: "Kota",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "NEGARA",
        label: "Negara",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_PIC_NAME",
        label: "PIC",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('14%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('14%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_PIC_DEPT",
        label: "Department",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "CO_PIC_EMAIL",
        label: "Email",
        options: {
          filter: true,
          sort: true,
          setCellHeaderProps: () => getHeaderProps('10%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('10%', '5px 0 5px 10px', 'left')
        },
      },
      { 
        name: "actions",
        label: " ",
        options: {
          filter: false,
          sort: false,
          download: false,
          setCellHeaderProps: () => getHeaderProps('4%', '5px 0 5px 0'),
          setCellProps: () => getCellProps('4%', '5px 0 5px 10px', 'left'),
          customBodyRender: actionRenderer
        },
      }
    ];

    return (
      // <Table data={items} col={columns} />
      <Datatables data={items} col={columns} title={'Daftar Partner'} />
    )
  }

  return (
    <PartnerListPageWrapper>
      <section className="content">
        <div className="row">
          <div className="col-lg-12">
            <div className="box">
              <div className="box-header" style={{marginTop: '4px'}}>
                <h3 className="box-title">Daftar Partner</h3>

                <div className="box-tools">
                  <button
                    disabled={!role.create}
                    className="btn btn-primary"
                    onClick={createPartner}
                  >
                    Tambah Baru
                  </button>
                </div>
              </div>
              {/* <div className="box-body table-responsive no-padding">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nama</th>
                      <th>Alamat</th>
                      <th>Kota</th>
                      <th>Negara</th>
                      <th>PIC</th>
                      <th>Department</th>
                      <th>Email</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    { renderPartner() }
                  </tbody>
                </table>
              </div> */}

              <div style={{padding: '0 10px 10px 10px'}}>
                { renderPartner() }
              </div>
            </div>
          </div>
        </div>
      </section>
    </PartnerListPageWrapper>
  );
};

const PartnerListPageWrapper = styled.div``;
